import { NavigationProp, useNavigation } from '@react-navigation/native';
import QRCameraReader from '_/components/QRCameraReader';
import {
  QRCODE_LOCATION_PREFIX,
  QRCODE_SLOT_PREFIX,
  QRCODE_SPACE_PREFIX,
} from '_/config/qrCodePrefix';
import { colors } from '_/constants/theme';
import { AppRoute } from '_/navigation/types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showMessage } from 'react-native-flash-message';

export default function QRCodeScannerFloat() {
  const navigation = useNavigation<NavigationProp<Record<string, unknown>>>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  async function handleQRCodeScanned(data: string) {
    setLoading(true);
    try {
      const prefix = data.slice(0, data.lastIndexOf('/') + 1);

      switch (prefix) {
        case QRCODE_SLOT_PREFIX: {
          const slotId = data.replace(QRCODE_SLOT_PREFIX, '');
          navigation.navigate(AppRoute.READING_QR_CODE, { slotId });
          break;
        }
        case QRCODE_LOCATION_PREFIX:
        case QRCODE_SPACE_PREFIX: {
          showMessage({
            message: t('error'),
            description: t('qrCodeScreen.errorMessages.prefixNotAllowed'),
            backgroundColor: colors.errorRed,
          });
          navigation.goBack();
          break;
        }
        default:
          showMessage({
            message: t('error'),
            description: t('qrCodeScreen.errorMessages.invalidQrCode'),
            backgroundColor: colors.errorRed,
          });
          navigation.goBack();
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <QRCameraReader
      onScanned={handleQRCodeScanned}
      onClose={() => navigation.goBack()}
      loading={loading}
    />
  );
}
